import { render } from "./OrgManagement.vue?vue&type=template&id=46998412&scoped=true"
import script from "./OrgManagement.vue?vue&type=script&lang=js"
export * from "./OrgManagement.vue?vue&type=script&lang=js"

import "./OrgManagement.vue?vue&type=style&index=0&id=46998412&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46998412"]])

export default __exports__